export enum DiscoverSpecialFolders {
    novice = 'novice',
    intermediate = 'intermediate',
    enthusiast = 'enthusiast',
}

export enum DiscoverTemplates {
    category = 'ContentMainCategory',
    subcategory = 'ContentSubCategory',
    segmentCodes = 'ContentSegmentCode',
    accountListCodes = 'ContentAccountListCode',
}

export enum DiscoverQueryParams {
    account = 'ac',
    segment = 'seg',
    os = 'o',
    gdpr = 'gdpr',
}

export enum ErrorPageType {
    common = 'common',
    noaccess = 'noaccess',
    nolocale = 'nolocale',
    notFound = 'notFound',
    unPublished = 'unPublished',
    /** 分享页面
     * 未找到内容
     * 文章已到期
     * 偏好流程页面
     * 视频弹出
     */
    noSharePage = 'noSharePage',
}
